import { apiUrl } from '../config/api'

export async function listWorkspacesByBrandLabel() {
  let params = {
    brandLabel: window.$brand
  }

  let url = apiUrl('ListWorkspacesByBrandLabel')

  return sendReq(params, url)
}

export async function listWorkspacesByClientId(clientId) {
  let params = {
    clientId: clientId
  }

  let url = apiUrl('ListAssignedWorkspacesByClient')

  return sendReq(params, url)
}

export async function listWorkspacesByUserId(userId) {
  let params = {
    userId: userId
  }

  let url = apiUrl('ListAssignedWorkspacesByUser')

  return sendReq(params, url)
}

export async function listWorkspaceSubcategories(workspaceId) {
  let params = {
    workspaceId: workspaceId
  }

  let url = apiUrl('ListWorkspaceSubcategories')

  return sendReq(params, url)
}

export async function listFilesByClient(clientId) {
  let params = {
    clientId: clientId
  }

  let url = apiUrl('ListFilesByClient')

  return sendReq(params, url)
}

async function sendReq(params, url) {
  let res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(params)
  }).catch((error) => console.log(error))
  return res.json()
}
